/* Angel kiwi variant — halo + tiny wings. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderAngel(p: KiwiPalette) {
  return (
    <>
      {/* Halo */}
      <path d="M10 2H22V4H10V2ZM8 4H10V6H8V4ZM22 4H24V6H22V4Z" fill={p.accent} opacity={0.35} />
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />
      {/* Highlight */}
      <rect x="20" y="10" width="2" height="2" fill={p.highlight} opacity={0.3} />
      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />
      {/* Eye */}
      <rect x="10" y="10" width="6" height="6" fill={p.eyeBg} />
      <rect x="12" y="12" width="2" height="2" fill={p.pupil} />
      {/* Wings */}
      <path d="M26 10H28V12H26V10ZM28 8H30V10H28V8ZM28 12H30V14H28V12ZM30 10H32V12H30V10Z" fill={p.accent} opacity={0.4} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
